// Copied from datastore/src/support/shared/constants/Constants.ts
// TODO: Remove that one in favor of this one.
export const AppStatus = {
  PENDING: 'Pending Review',
  APPROVED: 'Approved',
  ACTIVE: 'Active',
  DECLINED: 'Declined',
  WAITLISTED: 'Waitlisted',
};

export type Status = keyof typeof AppStatus;
